<template>
  <div
    class=""
    style="position: relative;">
    <div
      v-if="adv.status==='canceled' || !plan.adv_enabled || !adv.promoteur.plan.adv_enabled"
      class="frontdrop"></div>
    <div class="has-background-white is-border">
      <div
        class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-minH50p is-flex">
        <div class="is-self-centered">
          <span class="is-uppercase title is-6">Choix</span>
        </div>
      </div>
      <template v-for="(choice, idx) in choices">
        <choix-list
          :key="idx + '-choix'"
          :idx="idx"
          :source="choice"
          :can-edit="canEdit"
          :adv="adv"
          @deleteList="deleteList"></choix-list>
      </template>
      <div class="">
        <button
          class="page-header-btn button is-dark is-fullwidth is-radiusless"
          @click="addChoice">
          <span>Ajouter une liste</span>
        </button>
      </div>
    </div>

    <div class="has-background-white is-border is-margin-top-small">
      <div class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-minH50p is-flex">
        <div class="is-self-centered">
          <span class="is-uppercase title is-6">TMA</span>
        </div>
      </div>

      <div class="columns is-gapless has-background-white-bis is-border-top is-marginless-bottom">
        <div
          class="column is-narrow is-flex is-padding-small"
          :class="[(sale.choix_et_tma.tma.architect_devis && 'date' in sale.choix_et_tma.tma.architect_devis && sale.choix_et_tma.tma.architect_devis.date && 'amount' in sale.choix_et_tma.tma.architect_devis && sale.choix_et_tma.tma.architect_devis.amount) ? 'has-background-success' : 'has-background-danger']">
          <span class="icon has-text-white is-self-centered">
            <i
              v-if="sale.choix_et_tma.tma.architect_devis && 'date' in sale.choix_et_tma.tma.architect_devis && sale.choix_et_tma.tma.architect_devis.date && 'amount' in sale.choix_et_tma.tma.architect_devis && sale.choix_et_tma.tma.architect_devis.amount"
              class="fas fa-check-circle"></i>
            <i
              v-else
              class="fas fa-clock"></i>
          </span>
        </div>
        <div class="column is-padding-top">
          <div class="is-padding-left is-padding-bottom-small">
            <span class="title is-4 is-uppercase has-text-weight-medium">Devis architecte</span>
          </div>
          <div class="columns is-gapless is-padding-left is-marginless">
            <div class="column is-3 is-padding-right">
              <r-label
                :is-required="false"
                :label="'Devis TTC'"
                :for-id="'architect_devis_amount'"></r-label>
            </div>
            <div class="column is-3 is-padding-right">
              <r-label
                :is-required="false"
                :label="'Montant perçu'"
                :for-id="'architect_devis_amount_received'"></r-label>
            </div>
            <div class="column is-3 is-padding-right">
              <r-label
                :is-required="false"
                :label="'Montant restant à percevoir'"
                :for-id="'architect_devis_amount_remaining'"></r-label>
            </div>
            <div class="column">
              <r-label
                :is-required="false"
                :label="'Réception devis'"
                :for-id="''"></r-label>
            </div>
          </div>
          <div
            class="columns is-gapless is-margin-top-xxsmall is-padding-left has-background-white-ter is-vcentered is-border-top row-width-actions-bar"
            :class="{'has-content-disabled' : !(isAdmin && isPromoteur)}">
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p
                  class="control is-expanded"
                  :class="{'is-border': !(isAdmin && isPromoteur)}">
                  <input
                    id="architect_devis_amount"
                    type="number"
                    class="input has-text-centered has-text-weight-bold"
                    v-model.number="sale.choix_et_tma.tma.architect_devis.amount"
                    @input="$store.commit('modifyCurrentSale', { key: `choix_et_tma.tma.architect_devis.amount`, value: sale.choix_et_tma.tma.architect_devis.amount })"
                    :disabled="!isAdmin">
                </p>
                <p class="control is-nowrap">
                  <a class="button is-static is-border is-padding-left-xsmall is-padding-right-xsmall has-text-dark"><span class="has-text-weight-bold">€ TTC</span></a>
                </p>
              </div>
            </div>
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p
                  class="control is-expanded"
                  :class="{'is-border': !(isAdmin && isPromoteur)}">
                  <input
                    id="architect_devis_amount_received"
                    type="number"
                    class="input has-text-centered has-text-weight-bold"
                    v-model.number="sale.choix_et_tma.tma.architect_devis.amount_received"
                    @input="$store.commit('modifyCurrentSale', { key: `choix_et_tma.tma.architect_devis.amount_received`, value: sale.choix_et_tma.tma.architect_devis.amount_received })"
                    :disabled="!(isAdmin && isPromoteur)">
                </p>
                <p class="control is-nowrap">
                  <a class="button is-static is-border is-padding-left-xsmall is-padding-right-xsmall has-text-dark"><span class="has-text-weight-bold">€ TTC</span></a>
                </p>
              </div>
            </div>
            <div class="column is-2 is-padding-right">
              <div class="field has-addons">
                <p
                  class="control is-expanded"
                  :class="{'is-border': !(isAdmin && isPromoteur)}">
                  <input
                    id="architect_devis_amount_remaining"
                    type="number"
                    class="input has-text-centered has-text-weight-bold"
                    v-model.number="architect_devis_amount_remaining"
                    disabled>
                </p>
                <p class="control is-nowrap">
                  <a class="button is-static is-border is-padding-left-xsmall is-padding-right-xsmall has-text-dark"><span class="has-text-weight-bold">€ TTC</span></a>
                </p>
              </div>
            </div>
            <div class="column is-3">
              <date-picker
                :model="sale.choix_et_tma.tma.architect_devis.date"
                @input="$store.commit('modifyCurrentSale', { key: `choix_et_tma.tma.architect_devis.date`, value: $event })"
                class="is-self-centered"
                :field-class="'is-margin-left-xxsmall is-margin-right-xsmall is-self-centered'"
                :input-class="'is-fullwidth'"
                :style-version="2"
                :is-required="true"
                :disabled="!(isAdmin && isPromoteur)"></date-picker>
            </div>
            <div class="column"></div>
            <template v-if="'document' in sale.choix_et_tma.tma.architect_devis && sale.choix_et_tma.tma.architect_devis.document && 'cloudinary_id' in sale.choix_et_tma.tma.architect_devis.document && sale.choix_et_tma.tma.architect_devis.document.cloudinary_id">
              <div
                v-if="seeDocArchi"
                class="column is-narrow is-border-left">
                <button
                  class="page-header-btn is-small is-square tooltip is-tooltip-top"
                  @click="download(sale.choix_et_tma.tma.architect_devis.document.path)"
                  data-tooltip="Télécharger document lié">
                  <span
                    class="icon is-size-4"><i class="fal fa-download"></i></span>
                </button>
              </div>
              <div
                v-if="isAdmin && isPromoteur"
                class="column is-narrow is-border-left">
                <button
                  class="page-header-btn is-small is-square tooltip is-tooltip-top"
                  @click="unlink('architect_devis')"
                  data-tooltip="Supprimer document lié">
                  <span
                    class="icon is-size-4"><i class="fal fa-unlink"></i></span>
                </button>
              </div>
            </template>
            <template v-else-if="isAdmin && isPromoteur">
              <div class="column is-narrow has-background-white is-border-left">
                <div class="file">
                  <label
                    class="page-header-btn is-small is-square tooltip is-tooltip-top"
                    data-tooltip="Lier un document">
                    <input
                      class="file-input"
                      type="file"
                      accept="image/*, .pdf"
                      @change="processFile($event, 'architect_devis')"
                      name="resume">
                    <span>
                      <span
                        v-if="uploading === 'architect_devis'"
                        class="icon is-size-4"><i
                          class="fas fa-spinner fa-spin"></i></span>
                      <span
                        v-else
                        class="icon is-size-4 is-self-centered"><i class="fal fa-link"></i></span>
                    </span>
                  </label>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="columns is-gapless has-background-white-bis is-border-top is-marginless-bottom">
        <div
          class="column is-narrow is-flex is-padding-small"
          :class="[(sale.choix_et_tma.tma.promoteur_devis && sale.choix_et_tma.tma.promoteur_devis.date && sale.choix_et_tma.tma.promoteur_devis.amount) ? 'has-background-success' : 'has-background-danger']">
          <span class="icon has-text-white is-self-centered">
            <i
              v-if="sale.choix_et_tma.tma.promoteur_devis && sale.choix_et_tma.tma.promoteur_devis.date && sale.choix_et_tma.tma.promoteur_devis.amount"
              class="fas fa-check-circle"></i>
            <i
              v-else
              class="fas fa-clock"></i>
          </span>
        </div>
        <div class="column is-padding-top">
          <div class="is-padding-left is-padding-bottom-small">
            <span class="title is-4 is-uppercase has-text-weight-medium">Devis Promoteur</span>
          </div>
          <div class="columns is-gapless is-padding-left is-marginless">
            <div class="column is-3 is-padding-right">
              <r-label
                :is-required="false"
                :label="'Devis TTC'"
                :for-id="'promoteur_devis_amount'"></r-label>
            </div>
            <div class="column is-3 is-padding-right">
              <r-label
                :is-required="false"
                :label="'Montant perçu'"
                :for-id="'promoteur_devis_amount_received'"></r-label>
            </div>
            <div class="column is-3 is-padding-right">
              <r-label
                :is-required="false"
                :label="'Montant restant à percevoir'"
                :for-id="'promoteur_devis_amount_remaining'"></r-label>
            </div>
            <div class="column">
              <r-label
                :is-required="false"
                :label="'Réception devis'"
                :for-id="''"></r-label>
            </div>
          </div>

          <div
            :class="{'has-content-disabled' : !(isAdmin && isPromoteur)}"
            class="columns is-gapless is-margin-top-xxsmall is-padding-left has-background-white-ter is-vcentered is-border-top row-width-actions-bar">
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p
                  class="control is-expanded"
                  :class="{'is-border': !(isAdmin && isPromoteur)}">
                  <input
                    id="promoteur_devis_amount"
                    type="number"
                    class="input has-text-centered has-text-weight-bold"
                    v-model.number="sale.choix_et_tma.tma.promoteur_devis.amount"
                    @input="$store.commit('modifyCurrentSale', { key: `choix_et_tma.tma.promoteur_devis.amount`, value: sale.choix_et_tma.tma.promoteur_devis.amount })"
                    :disabled="!(isAdmin && isPromoteur)">
                </p>
                <p class="control is-nowrap">
                  <a class="button is-static is-border is-padding-left-xsmall is-padding-right-xsmall has-text-dark"><span class="has-text-weight-bold">€ TTC</span></a>
                </p>
              </div>
            </div>
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p
                  class="control is-expanded"
                  :class="{'is-border': !(isAdmin && isPromoteur)}">
                  <input
                    id="promoteur_devis_amount_received"
                    type="number"
                    class="input has-text-centered has-text-weight-bold"
                    v-model.number="sale.choix_et_tma.tma.promoteur_devis.amount_received"
                    @input="$store.commit('modifyCurrentSale', { key: `choix_et_tma.tma.promoteur_devis.amount_received`, value: sale.choix_et_tma.tma.promoteur_devis.amount_received })"
                    :disabled="!(isAdmin && isPromoteur)">
                </p>
                <p class="control is-nowrap">
                  <a class="button is-static is-border is-padding-left-xsmall is-padding-right-xsmall has-text-dark"><span class="has-text-weight-bold">€ TTC</span></a>
                </p>
              </div>
            </div>
            <div class="column is-2 is-padding-right">
              <div class="field has-addons">
                <p
                  class="control is-expanded"
                  :class="{'is-border': !(isAdmin && isPromoteur)}">
                  <input
                    id="promoteur_devis_amount_remaining"
                    type="number"
                    class="input has-text-centered has-text-weight-bold"
                    v-model.number="promoteur_devis_amount_remaining"
                    disabled>
                </p>
                <p class="control is-nowrap">
                  <a class="button is-static is-border is-padding-left-xsmall is-padding-right-xsmall has-text-dark"><span class="has-text-weight-bold">€ TTC</span></a>
                </p>
              </div>
            </div>
            <div class="column is-3">
              <date-picker
                :model="sale.choix_et_tma.tma.promoteur_devis.date"
                @input="$store.commit('modifyCurrentSale', { key: `choix_et_tma.tma.promoteur_devis.date`, value: $event })"
                class="is-self-centered"
                :field-class="'is-margin-left-xxsmall is-margin-right-xsmall is-self-centered'"
                :input-class="'is-fullwidth'"
                :style-version="2"
                :is-required="true"
                :disabled="!(isAdmin && isPromoteur)"></date-picker>
            </div>
            <div class="column"></div>
            <template v-if="sale.choix_et_tma.tma.promoteur_devis.document && 'cloudinary_id' in sale.choix_et_tma.tma.promoteur_devis.document && sale.choix_et_tma.tma.promoteur_devis.document.cloudinary_id">
              <div
                v-if="seeDocPromoteur"
                class="column is-narrow is-border-left">
                <button
                  class="page-header-btn is-small is-square tooltip is-tooltip-top"
                  @click="download(sale.choix_et_tma.tma.promoteur_devis.document.path)"
                  data-tooltip="Télécharger document lié">
                  <span
                    class="icon is-size-4"><i class="fal fa-download"></i></span>
                </button>
              </div>
              <div class="column is-narrow is-border-left">
                <button
                  class="page-header-btn is-small is-square tooltip is-tooltip-top"
                  @click="unlink('promoteur_devis')"
                  data-tooltip="Supprimer document lié">
                  <span
                    class="icon is-size-4"><i class="fal fa-unlink"></i></span>
                </button>
              </div>
            </template>
            <template v-else-if="isAdmin && isPromoteur">
              <div class="column is-narrow has-background-white is-border-left">
                <div class="file">
                  <label
                    class="page-header-btn is-small is-square tooltip is-tooltip-top"
                    data-tooltip="Lier un document">
                    <input
                      class="file-input"
                      type="file"
                      accept="image/*, .pdf"
                      @change="processFile($event, 'promoteur_devis')"
                      name="resume">
                    <span class="">
                      <span
                        v-if="uploading === 'promoteur_devis'"
                        class="icon is-size-4"><i
                          class="fas fa-spinner fa-spin"></i></span>
                      <span
                        v-else
                        class="icon is-size-4 is-self-centered"><i class="fal fa-link"></i></span>
                    </span>
                  </label>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="columns is-gapless has-background-white-bis is-border-top is-marginless-bottom">
        <div
          class="column is-narrow is-flex is-padding-small"
          :class="[(sale.choix_et_tma.tma.accepted_devis && sale.choix_et_tma.tma.accepted_devis.date && sale.choix_et_tma.tma.accepted_devis.amount) ? 'has-background-success' : 'has-background-danger']">
          <span class="icon has-text-white is-self-centered">
            <i
              v-if="sale.choix_et_tma.tma.accepted_devis && sale.choix_et_tma.tma.accepted_devis.date && sale.choix_et_tma.tma.accepted_devis.amount"
              class="fas fa-check-circle"></i>
            <i
              v-else
              class="fas fa-clock"></i>
          </span>
        </div>
        <div class="column is-padding-top">
          <div class="is-padding-left is-padding-bottom-small">
            <span class="title is-4 is-uppercase has-text-weight-medium">Devis client</span>
          </div>
          <div class="columns is-gapless is-padding-left is-marginless">
            <div class="column is-3 is-padding-right">
              <r-label
                :is-required="false"
                :label="'Devis TTC'"
                :for-id="'accepted_devis_amount'"></r-label>
            </div>
            <div class="column is-3 is-padding-right">
              <label
                for=""
                class="label"></label>
              <r-label
                :is-required="false"
                :label="'Montant perçu'"
                :for-id="'accepted_devis_amount_received'"></r-label>
            </div>
            <div class="column is-3 is-padding-right">
              <label
                for=""
                class="label"></label>
              <r-label
                :is-required="false"
                :label="'Montant restant à percevoir'"
                :for-id="'accepted_devis_amount_remaining'"></r-label>
            </div>
            <div class="column">
              <label
                for=""
                class="label"></label>
              <r-label
                :is-required="false"
                :label="'Réception devis'"
                :for-id="''"></r-label>
            </div>
          </div>
          <div
            :class="{'has-content-disabled' : !(isAdmin && isPromoteur)}"
            class="columns is-gapless is-margin-top-xxsmall is-padding-left has-background-white-ter is-vcentered is-border-top row-width-actions-bar">
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p
                  class="control is-expanded"
                  :class="{'is-border': !(isAdmin && isPromoteur)}">
                  <input
                    id="accepted_devis_amount"
                    type="number"
                    class="input has-text-centered has-text-weight-bold"
                    v-model.number="sale.choix_et_tma.tma.accepted_devis.amount"
                    @input="$store.commit('modifyCurrentSale', { key: `choix_et_tma.tma.accepted_devis.amount`, value: sale.choix_et_tma.tma.accepted_devis.amount })"
                    :disabled="!(isAdmin && isPromoteur)">
                </p>
                <p class="control is-nowrap">
                  <a class="button is-static is-border is-padding-left-xsmall is-padding-right-xsmall has-text-dark"><span class="has-text-weight-bold">€ TTC</span></a>
                </p>
              </div>
            </div>
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p
                  class="control is-expanded"
                  :class="{'is-border': !(isAdmin && isPromoteur)}">
                  <input
                    id="accepted_devis_amount_received"
                    type="number"
                    class="input has-text-centered has-text-weight-bold"
                    v-model.number="sale.choix_et_tma.tma.accepted_devis.amount_received"
                    @input="$store.commit('modifyCurrentSale', { key: `choix_et_tma.tma.accepted_devis.amount_received`, value: sale.choix_et_tma.tma.accepted_devis.amount_received })"
                    :disabled="!(isAdmin && isPromoteur)">
                </p>
                <p class="control is-nowrap">
                  <a class="button is-static is-border is-padding-left-xsmall is-padding-right-xsmall has-text-dark"><span class="has-text-weight-bold">€ TTC</span></a>
                </p>
              </div>
            </div>
            <div class="column is-2 is-padding-right">
              <div class="field has-addons">
                <p
                  class="control is-expanded"
                  :class="{'is-border': !(isAdmin && isPromoteur)}">
                  <input
                    id="accepted_devis_amount_remaining"
                    type="number"
                    class="input has-text-centered has-text-weight-bold"
                    v-model.number="accepted_devis_amount_remaining"
                    disabled>
                </p>
                <p class="control is-nowrap">
                  <a class="button is-static is-border is-padding-left-xsmall is-padding-right-xsmall has-text-dark"><span class="has-text-weight-bold">€ TTC</span></a>
                </p>
              </div>
            </div>
            <div class="column is-3">
              <date-picker
                :model="sale.choix_et_tma.tma.accepted_devis.date"
                @input="$store.commit('modifyCurrentSale', { key: `choix_et_tma.tma.accepted_devis.date`, value: $event })"
                class="is-self-centered"
                :field-class="'is-margin-left-xxsmall is-margin-right-xsmall is-self-centered'"
                :input-class="'is-fullwidth'"
                :style-version="2"
                :is-required="true"
                :disabled="!(isAdmin && isPromoteur)"></date-picker>
            </div>
            <div class="column"></div>
            <template v-if="sale.choix_et_tma.tma.accepted_devis.document && 'cloudinary_id' in sale.choix_et_tma.tma.accepted_devis.document && sale.choix_et_tma.tma.accepted_devis.document.cloudinary_id">
              <div
                v-if="seeDocDevis"
                class="column is-narrow is-border-left">
                <button
                  class="page-header-btn is-small is-square tooltip is-tooltip-top"
                  @click="download(sale.choix_et_tma.tma.accepted_devis.document.path)"
                  data-tooltip="Télécharger document lié">
                  <span
                    class="icon is-size-4"><i class="fal fa-download"></i></span>
                </button>
              </div>
              <div class="column is-narrow is-border-left">
                <button
                  class="page-header-btn is-small is-square tooltip is-tooltip-top"
                  @click="unlink('accepted_devis')"
                  data-tooltip="Supprimer document lié">
                  <span
                    class="icon is-size-4"><i class="fal fa-unlink"></i></span>
                </button>
              </div>
            </template>
            <template v-else-if="isAdmin && isPromoteur">
              <div class="column is-narrow has-background-white is-border-left">
                <div class="file">
                  <label
                    class="page-header-btn is-small is-square tooltip is-tooltip-top"
                    data-tooltip="Lier un document">
                    <input
                      class="file-input"
                      type="file"
                      accept="image/*, .pdf"
                      @change="processFile($event, 'accepted_devis')"
                      name="resume">
                    <span class="">
                      <span
                        v-if="uploading === 'accepted_devis'"
                        class="icon is-size-4"><i
                          class="fas fa-spinner fa-spin"></i></span>
                      <span
                        v-else
                        class="icon is-size-4 is-self-centered"><i class="fal fa-link"></i></span>
                    </span>
                  </label>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="isAdmin && isPromoteur || currentUser.active_all_contact"
      class="has-background-white is-border-top is-margin-top-small">
      <div class="row-width-actions-bar columns is-gapless is-marginless">
        <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="is-uppercase title is-6">Commentaire</span>
        </div>
        <div class="column is-narrow is-border-left">
        </div>
      </div>
      <template v-if="openComment">
        <div
          v-if="!openCommentWysi && comment"
          @click="openWysiwyg"
          class="vadDiscussion is-border-top"
          style="cursor: pointer;">
          <div
            class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
            <div
              class="content"
              v-if="(isAdmin || currentUser.active_all_contact) && comment"
              v-html="comment"></div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="">
                <button
                  @click="openWysiwyg"
                  class="is-min-height-full">
                  <span class="icon is-small"><i class="fal fa-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="is-border-top columns is-gapless">
          <div class="column">
            <wysiwyg-editor
              :light="true"
              :tooltip-top="true"
              :model="comment"
              @change="val => comment = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div>
              <button
                @click="patchComment()"
                type="button"
                class="button"
                :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
                :disabled="(baseComment === comment)">
                <span class="icon is-small">
                  <i
                    v-if="loadComment"
                    class="fas fa-spinner fa-spin"></i>
                  <i
                    v-else
                    class="fal fa-save"></i>
                </span>
              </button>
            </div>
            <div class="">
              <button
                :disabled="!baseComment"
                type="button"
                :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                @click="comment?openCommentWysi = false:null; comment = baseComment">
                <span class="icon is-small"><i class="fal fa-times"></i></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Adv, DefaultValues, Upload } from '@/mixins'

export default {
  name: 'ChoixEtTma',
  components: {
    ChoixList: () => import('./ChoixList')
  },
  mixins: [Adv, DefaultValues, Upload],
  data () {
    return {
      validDocument: null,
      choices: [],
      uploading: null
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isPromoteur']),
    /**
      * display doc archi
      * @returns {boolean}
      */
    seeDocArchi () {
      if (this.isAdmin && this.isPromoteur) return true
      else if ('document' in this.sale.choix_et_tma.tma.architect_devis && this.sale.choix_et_tma.tma.architect_devis.document) {
        if ('display' in this.sale.choix_et_tma.tma.architect_devis.document && this.sale.choix_et_tma.tma.architect_devis.document.display) return true
        else return false
      } else {
        return false
      }
    },
    /**
      * display doc promoteur
      * @returns {boolean}
      */
    seeDocPromoteur () {
      if (this.isAdmin && this.isPromoteur) return true
      else if ('document' in this.tma.promoteur_devis && this.tma.promoteur_devis.document) {
        if ('display' in this.tma.promoteur_devis.document && this.tma.promoteur_devis.document.display) return true
        else return false
      } else {
        return false
      }
    },
    /**
      * display doc devis
      * @returns {boolean}
      */
    seeDocDevis () {
      if (this.isAdmin && this.isPromoteur) return true
      else if ('document' in this.tma.accepted_devis && this.tma.accepted_devis.document) {
        if ('display' in this.tma.accepted_devis.document && this.tma.accepted_devis.document.display) return true
        else return false
      } else {
        return false
      }
    },
    architect_devis_amount_remaining () {
      if (this.sale.choix_et_tma.tma.architect_devis.amount) {
        return this.sale.choix_et_tma.tma.architect_devis.amount - this.sale.choix_et_tma.tma.architect_devis.amount_received
      } else return null
    },
    promoteur_devis_amount_remaining () {
      if (this.sale.choix_et_tma.tma.promoteur_devis.amount) {
        return this.sale.choix_et_tma.tma.promoteur_devis.amount - this.sale.choix_et_tma.tma.promoteur_devis.amount_received
      } else return null
    },
    accepted_devis_amount_remaining () {
      if (this.sale.choix_et_tma.tma.accepted_devis.amount) {
        return this.sale.choix_et_tma.tma.accepted_devis.amount - this.sale.choix_et_tma.tma.accepted_devis.amount_received
      } else return null
    }
  },
  created () {
    if (this.sale.choix_et_tma.choices && this.sale.choix_et_tma.choices.length) {
      this.choices = this.sale.choix_et_tma.choices.slice()
    } else this.addChoice(false)

    let devis = {
      amount: null,
      amount_received: null,
      date: null,
      document: null
    }
    if (this.sale.choix_et_tma.tma.accepted_devis === null) {
      this.sale.choix_et_tma.tma.accepted_devis = Object.assign({}, devis)
    }

    if (this.sale.choix_et_tma.tma.architect_devis === null) {
      this.sale.choix_et_tma.tma.architect_devis = Object.assign({}, devis)
    }

    if (this.sale.choix_et_tma.tma.promoteur_devis === null) {
      this.sale.choix_et_tma.tma.promoteur_devis = Object.assign({}, devis)
    }
  },
  methods: {
    /**
      * process file
      * @param {object} event
      * @param {string} from
      */
    async processFile (event, from) {
      let file = event.target.files[0]
      this.validDocument = await this.checkAutorizedFile(file)
      if (this.validDocument === false) {
        setTimeout(() => {
          this.validDocument = null
        }, 2000)
        return
      }
      let files = new FormData()
      files.append('file[]', file, file.name)
      this.uploading = from
      let document = null
      try {
        await this.setFusToken()
        let res = await this.$fus.post({ data: files })
        document = res.data[0]
        document.fus_id = document.id
        document.filename = file.name
        document.destination = ['display_in_adv']
      } catch (e) {
        console.log(e)
      }
      if (document) {
        this.sale.choix_et_tma.tma[from].document = Object.assign({}, document)
        this.uploading = null
        this.$store.commit('modifyCurrentSale', { key: `sale.choix_et_tma.tma[${from}].document`, value: this.sale.choix_et_tma.tma[from].document })
      } else {
        this.uploading = null
      }
    },
    /**
      * download link
      * @param {string} href
      */
    download (href) {
      let link = document.createElement('a')
      link.href = href
      link.target = '_blank'
      link.click()
    },
    /**
      * add choice in choix_et_tma
      * @param {boolean} save
      */
    addChoice (save = true) {
      if ((this.isAdmin && this.isPromoteur) || this.choices.length < 1) {
        this.choices.push({
          name: null,
          comment: null
        })
        if (save) {
          this.$store.commit('modifyCurrentSale', { key: `choix_et_tma.choices`, value: this.choices })
        }
      }
    },
    /**
      * delete document linked
      * @param {string} from
      */
    unlink (from) {
      this.sale.choix_et_tma.tma[from].document = null
      this.$store.commit('modifyCurrentSale', { key: `sale.choix_et_tma.tma[${from}].document`, value: null })
    },
    /**
      * delete list
      * @param {number} index
      */
    deleteList (index) {
      this.choices.splice(index, 1)
      this.$store.commit('modifyCurrentSale', { key: `choix_et_tma.choices`, value: this.choices })
    }
  }
}
</script>
